import React from 'react';
import styles from './PublishSuccessPopup.module.scss';
import { BASE_IMG_URL } from '@images/imageUrls';
import ActivityList from '@components/activityList';

interface PublishSuccessPopupProps {
    visible: boolean;
    avatar?: string;
    threadId?: string | number | null;
    activityList?: any[];
    activityLoading?: boolean;
    onClose?: () => void;
    onBackHome: () => void;
    onViewDetail: () => void;
};

const PublishSuccessPopup: React.FC<PublishSuccessPopupProps> = ({
    visible,
    avatar,
    activityList = [],
    activityLoading = false,
    onClose,
    onBackHome,
    onViewDetail,
}) => {
    if (!visible) return null;

    const normalizedActivityList = Array.isArray(activityList) ? activityList : [];

    return (
        <div className={styles.overlay}>
            <div className={styles.mask} onClick={onClose} />
            <div className={styles.popup} data-body-scroll-lock-scrollable>
                <div className={styles.header}>
                    <img
                        src={avatar || `${BASE_IMG_URL}/common/avatar.png`}
                        alt=""
                        className={styles.avatar}
                    />
                    <div className={styles.title}>感谢你的反馈</div>
                    <div className={styles.buttonRow}>
                        <button className={styles.secondaryBtn} onClick={onBackHome}>回到首页</button>
                        <button className={styles.primaryBtn} onClick={onViewDetail}>查看帖子详情</button>
                    </div>
                    <div className={styles.rewardText}>
                        <span>参与活动，赢更多</span>
                        <span className={styles.rewardHighlight}>发帖奖励</span>
                    </div>
                </div>

                <div className={styles.activitySection}>
                    <ActivityList
                        data={normalizedActivityList}
                        loading={activityLoading}
                        hasMore={false}
                        onLoadMore={() => {}}
                        emptyText="暂无活动"
                        emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    />
                </div>
            </div>
        </div>
    );
};

export default PublishSuccessPopup;
